<label for="{{optionId}}">
  <input id="{{optionId}}" (click)="toggleCheck()" type="checkbox" [checked]="isChecked" [value]="option.value" />
  @if (!toTranslate) {
    <span>{{ option.label }}</span>
  }
  @if (toTranslate) {
    <span>{{ option.label | uppercase | translate }}</span>
  }
</label>
